import React, {Component} from 'react';
import ListingContainer from "../../../containers/listing_container";
import {Button, Form, Grid, Header, Label, Segment} from "semantic-ui-react";
import {ADMIN_API_URL} from "../../../constants/api_routes";

class UpdateAdminUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            disableSave:false
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        this.setState({disableSave:true});
        this.props.updateDetails(ADMIN_API_URL, formData, this.props.selectedObject[0].id,this.successCallback);
    };

    successCallback = (response) => {
        if (response.success || response['admin_user']) {
            this.props.onSuccess();
        }
    };

    render() {
        const currentEditingUser = this.props.selectedObject[0];
        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Update Admin User
                </Header>
                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Column width={8}>
                            <Segment className='segment-width'>
                                <Label color='blue' ribbon>
                                    Profile Details
                                </Label>
                                <p></p>
                                <p style={{fontWeight: 600, fontSize: '1.3rem'}}>Email: <span
                                    style={{fontWeight: 200}}>{currentEditingUser.email}</span>
                                </p>
                                <Form.Input label='Name' fluid icon='user' iconPosition='left' placeholder='Name'
                                            type='text' name="name" defaultValue={currentEditingUser.name}
                                            required/>
                                <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                            placeholder='328659286'
                                            type='text' name="mobile_number"
                                            defaultValue={currentEditingUser['mobile_number']}
                                            required/>
                                <div className='clearfix-placeholder'>

                                </div>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Address Details
                                </Label>
                                <p></p>
                                <Form.Input label='Address Line 1' fluid
                                            placeholder='Street'
                                            type='street view'
                                            name="line1"
                                            defaultValue={currentEditingUser.line1}
                                            required/>
                                <Form.Input label='Address Line 2' fluid
                                            placeholder='Landmark'
                                            type='street view'
                                            name="line2"
                                            defaultValue={currentEditingUser.line2}
                                            required
                                />
                                <Form.Group widths={2}>
                                    <Form.Input label='Locality' fluid
                                                placeholder='Region'
                                                type='text'
                                                name="locality"
                                                defaultValue={currentEditingUser.locality}
                                    />
                                    <Form.Input label='City' fluid
                                                placeholder='City'
                                                type='text'
                                                name="city"
                                                defaultValue={currentEditingUser.city}
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                                    <Form.Input label='Country' fluid
                                                placeholder='Country'
                                                type='text'
                                                name="country"
                                                defaultValue={currentEditingUser.country}
                                    />
                                    <Form.Input label='Post Code' fluid
                                                placeholder='C2PN57'
                                                type='text'
                                                name="postcode"
                                                defaultValue={currentEditingUser.postcode}
                                                required
                                    />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        <div className="submit-buttons">
                            <Button primary fluid disabled={this.state.disableSave}>Update User</Button>
                        </div>
                    </Grid>
                </Form>
            </div>
        );
    }

}

export default ListingContainer(UpdateAdminUser);


// WEBPACK FOOTER //
// ./src/views/user/admin/update_user.js